import React from 'react'
import { SvgIcon, Tooltip } from '@mui/material'
import { ActivityStatusDetails } from '../../../../shared/hooks/useActivityStatuses/useActivityStatuses.types'

export const ActivityStatusIcon = ({ status }: { status: ActivityStatusDetails }) => (
    <Tooltip title={status.name}>
        <SvgIcon component={status.icon} inheritViewBox fontSize="small" aria-label={status.name} />
    </Tooltip>
)

export default ActivityStatusIcon
